import React from 'react';
import { MdArrowBack } from 'react-icons/md';

// Mirrors the kit OpenAccountsScreen mobile variant: green hero +
// stack of product cards. The CTA hands off to chat with a product-
// specific opening prompt so the assistant knows exactly which product
// the user was looking at and can pick up the conversation.
const PRODUCTS = [
  {
    title: 'TD Every Day Chequing',
    description: 'A no-frills chequing account with everything you need for daily banking.',
    features: [
      'Free Interac e-Transfers',
      'Mobile cheque deposit',
      'Overdraft protection optional',
      'Free TD ATMs across Canada',
    ],
    cta: 'Open Chequing',
    seed: "I'd like to open a TD Every Day Chequing account. Can you walk me through how to get started?",
  },
  {
    title: 'TD High Interest Savings',
    rate: '3.50% APY',
    description: 'Grow your savings with a competitive interest rate and no monthly fees.',
    features: [
      'No monthly maintenance fees',
      'Daily interest calculation',
      'No minimum balance',
      'Easy transfers to chequing',
    ],
    cta: 'Start Saving',
    seed: "I'd like to open a TD High Interest Savings account. What's the application process and the current rate?",
  },
  {
    title: 'TD Cash Back Visa',
    rate: '3% Cash Back',
    description: 'Earn cash back on every purchase with no annual fee in your first year.',
    features: [
      '3% on groceries and gas',
      '1% on everything else',
      'No foreign transaction fees',
      'Contactless tap & pay',
    ],
    cta: 'Apply Now',
    seed: "I'd like to apply for a TD Cash Back Visa. Can you tell me about the rewards, fees, and how to apply?",
  },
  {
    title: 'TD TFSA Investment Account',
    rate: 'Tax-free',
    description: 'Invest in stocks, ETFs and GICs without paying tax on your gains.',
    features: [
      'No tax on growth or withdrawals',
      'Stocks, ETFs, mutual funds, GICs',
      '$7,000 contribution limit (2026)',
      'Free trading first 90 days',
    ],
    cta: 'Open TFSA',
    seed: "I'd like to open a TD TFSA Investment account. How does the contribution room work and what can I invest in?",
  },
];

const OpenAccountsScreen = ({ onNavigate, onBack, onChatHandoff }) => (
  <div className="screen bh-flow">
    <header className="bh-flow-hero">
      <div className="bh-flow-hero-left">
        <button className="bh-flow-back" onClick={onBack || (() => onNavigate('services'))} aria-label="Back to services">
          <MdArrowBack />
        </button>
        <h1 className="bh-flow-title">Open an Account</h1>
      </div>
    </header>

    <div className="bh-flow-body">
      <div className="bh-form-card" style={{ alignItems: 'flex-start', gap: 'var(--space-3xs)' }}>
        <h2 style={{ margin: 0, font: 'var(--bh-h3)', color: 'var(--bh-black)' }}>
          Pick the right account
        </h2>
        <p style={{ margin: 0, font: 'var(--bh-body-sm)', color: 'var(--bh-gray)' }}>
          Whether you're saving for the future or managing day-to-day finances, we have an account that fits.
        </p>
      </div>

      {PRODUCTS.map(p => (
        <article key={p.title} className="bh-product-card">
          <h3 className="bh-product-card-title">{p.title}</h3>
          {p.rate && <p className="bh-product-card-rate">{p.rate}</p>}
          <p className="bh-product-card-desc">{p.description}</p>
          <ul className="bh-product-card-features">
            {p.features.map(f => <li key={f}>{f}</li>)}
          </ul>
          <button
            className="bh-btn-cta"
            onClick={() => {
              if (onChatHandoff) onChatHandoff(p.seed);
              else onNavigate('chat');
            }}
          >
            {p.cta}
          </button>
        </article>
      ))}
    </div>
  </div>
);

export default OpenAccountsScreen;
